import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    width: '180px',
  },
}));

export default useStyles;
